export default __webpack_public_path__ + "static/media/velo.c47e49e4.svg";